import React from 'react';
import { Group } from '@mantine/core';
import useTranslation from 'next-translate/useTranslation';

import { Text } from '~/domains/design-system/Text';
import { Avatar } from '~/domains/design-system/Avatar';

import useStyles from '~/domains/common/components/AlertCard/alertCard.styles';
import type { ContestInvite } from './types';

const getInviteActionConfig = (
  invite: ContestInvite,
  t: (key: string) => string
): { text: string; showUserAvatar: boolean } => ({
  // TODO: add renewal invite type logic when we receive from BE
  // switch (invite.type) {
  //   case InviteType.CONTEST_RENEWAL:
  //     return {
  //       text: t('common.contestInviteCard.inviterInfo.contestRenewed'),
  //       showUserAvatar: false,
  //     };
  //   case InviteType.CONTEST_INVITE:
  //   default:
  // }
  text: `${invite.contest?.owner?.handle} ${t('common.contestInviteCard.inviterInfo.invitedYou')}`,
  showUserAvatar: true,
});

function ContestInviteCardInviterInfo({ invite }: { invite: ContestInvite }) {
  const { classes } = useStyles();
  const { t } = useTranslation('contest');

  const { text, showUserAvatar } = getInviteActionConfig(invite, t);

  return (
    <Group spacing="xs">
      {showUserAvatar && (
        <Avatar
          src={invite.contest?.owner?.avatarUrl}
          handle={invite.contest?.owner?.handle}
          size={24}
        />
      )}
      <Text className={classes.inviterName}>{text}</Text>
    </Group>
  );
}

export default ContestInviteCardInviterInfo;
